var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75896 5.45905L11.441 2.11803C11.7929 1.94208 12.2071 1.94208 12.559 2.11803L19.241 5.45905C20.1441 5.91056 20.1669 7.191 19.2806 7.67445L12.5986 11.3192C12.2255 11.5227 11.7745 11.5227 11.4014 11.3192L4.71941 7.67445C3.83307 7.191 3.85593 5.91056 4.75896 5.45905Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 17.672V11.8127C2.75 10.8721 3.7498 10.2685 4.58219 10.7066L10.0822 13.6013C10.4929 13.8175 10.75 14.2434 10.75 14.7075V19.9878C10.75 20.8818 9.83885 21.4868 9.01493 21.1399L3.51493 18.8241C3.05141 18.6289 2.75 18.175 2.75 17.672Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 17.672V11.8127C21.25 10.8721 20.2502 10.2685 19.4178 10.7066L13.9178 13.6013C13.5071 13.8175 13.25 14.2434 13.25 14.7075V19.9878C13.25 20.8818 14.1612 21.4868 14.9851 21.1399L20.4851 18.8241C20.9486 18.6289 21.25 18.175 21.25 17.672Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/Cube.6751dded.svg";
export { ForwardRef as ReactComponent };